import React, { Component, createRef } from 'react';
// import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-dt';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.css';
import 'datatables.net-responsive-bs4';

const $ = require('jquery');
class Table extends Component {
    constructor(props) {
        // console.log("table cons called");
        super(props);
        this.state = {
            data: props.data,
            tableRef: createRef(),
            columns: props.schema,
        }
        this.tableComponent = null;
        this.tableComponentObj = null;
    }
    componentDidMount() {
        if (!this.tableComponent) {
            // console.log("table initialized.")
            // $.fn.dataTable.ext.errMode = 'throw';

            this.tableComponent = $(this.state.tableRef.current);
            this.tableComponentObj = this.tableComponent.DataTable({
                responsive: true,
                columns: this.state.columns,
                ordering: true,
                order: [[0, 'desc']],
                data: this.state.data
            });

            const BTNFunctions = this.props.buttonTasks || [];
            BTNFunctions.forEach(element => {
                const triggerFN = (event) => {
                    var rowSelector = $(event.target).parents('tr');
                    if (rowSelector[0].getAttribute("role") !== "row") {
                        rowSelector = rowSelector.prev();
                    }
                    var row = this.tableComponentObj.row(rowSelector[0]).data();
                    // console.log(this.tableComponent);
                    element.task(row);
                }
                this.tableComponent.find('tbody').on('click', `button.${element.className}`, triggerFN);
            })
            // const triggerFN = (event) => {
            //     var row=this.tableComponentObj.row($(event.target).parents('tr')[0]).data();
            //     // console.log(this.tableComponent);
            //     this.props.handleEditBlog(row);
            // }
            // this.tableComponent.find('tbody').on('click', 'button.editBlog', triggerFN);

        }
    }

    componentWillUnmount() {
        this.tableComponent.DataTable().destroy(true);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.data !== this.state.data) {
            this.setState({ data: nextProps.data })
        }
        if (this.state.data !== nextState.data)
            this.reloadTableData(nextProps.data);

        return false;
    }

    reloadTableData(pdata) {
        const table = this.tableComponent.DataTable();
        table.clear();
        table.rows.add(pdata);
        table.draw();
        // console.log('table drawn');
    }
    render() {
        return (
            <div>
                {/* <table ref="main" /> */}
                <table className="table table-striped table-bordered" style={{ width: '100%' }} id="dataTable" ref={this.state.tableRef} />
            </div>
        );
    }
}



// export default connect(({ blogs }) => ({ blogs }), { fetchBlogs })(Table1);
export default Table;